import { httpRequest } from '@/utils/HttpRequest'
import { Key } from 'react'

/***************************fms************************* */
interface ITreeDs<T> {
    enable?: number
    code?: string
    children?: T[]
}

export interface ITreeData<T> {
    key: Key
    title?: string
    children?: ITreeData<T>[] | undefined
}

export interface IFieldValue<T> {
    [key: string]: T[keyof T]
}

export function trasDsToTreeData<T extends ITreeDs<T>>(ds: T[], keyField: keyof T, titleField: keyof T): ITreeData<T>[] {
    return ds.map((el) => {
        const key = el[keyField] as any
        const title = el[titleField] as any
        const children = el.children && el.children.length > 0 ? trasDsToTreeData(el.children, keyField, titleField) : undefined
        const disabled = el.enable === 0
        return {
            el,
            key,
            title,
            disabled,
            value: el['code'],
            selectable: !disabled,
            children,
        }
    })
}
/*********************************************************************************** */

export interface IThreeTestItemSearch {
    page?: {
        pageSize: number
        pageNum: number
    }
    value?: string
    sourceApp?: string
    [key: string]: any
}

export interface IThreeTestItemDetail {
    note?: string
    ver: number
    code: string
    sourceAuthKey?: string
    pcode: string | null
    children: IThreeTestItemDetail[]
    enable: number | boolean
    name: string
    value?: string
    key: string
    [key: string]: any
}

export interface IThreeTestItemInsert {
    sourceApp?: string
    code: string
    name: string
    value?: string
    pcode?: string | null
    note?: string
}
export interface IThreeTestItemUpdate {
    sourceApp?: string
    code: string
    value?: string
}

export interface IThreeTestItemOne {
    sourceApp?: string
    code: string
}

export interface IThreeTestItemSync {
    sourceApp?: string
    branchList?: string[]
}

class ThreeTestItemService {
    //树列表
    async page(searchVo: IThreeTestItemSearch) {
        const apiUrl = '/threeInspection/item/list'
        return await httpRequest.post<any>(apiUrl, searchVo)
    }
    //新增
    async insert(insertVo: any) {
        const apiUrl = '/threeInspection/item/insert'
        return await httpRequest.post<boolean>(apiUrl, insertVo)
    }
    //编辑
    async update(updateVo: any) {
        const apiUrl = '/threeInspection/item/update'
        return await httpRequest.post<boolean>(apiUrl, updateVo)
    }
    //获取一条
    async one(oneVo: any) {
        const apiUrl = '/threeInspection/dict/one'
        return await httpRequest.post<IThreeTestItemDetail>(apiUrl, oneVo)
    }

    //禁用
    async disable(oneVo: any) {
        const apiUrl = '/tco/dict/disable'
        return await httpRequest.post<boolean>(apiUrl, oneVo)
    }

    async remove(oneVo: any) {
        const apiUrl = '/threeInspection/item/delete'
        return await httpRequest.post<boolean>(apiUrl, oneVo)
    }
    async sync(obj: any) {
        const apiUrl = '/tco/base/dict/sync'
        return await httpRequest.post<boolean>(apiUrl, obj)
    }
}

export const threeTestItemService = new ThreeTestItemService()
